import Api from '../../api/index'

const Notification = {
  namespaced: true,
  state: {
    oneNotification: null, //to store SHOW response
    allNotifications: null,

    unopenedNotifications: [],
    count_new_notifications: 0,
    
    openedNotifications: [],
  },
  getters: {
    // getTotalNotification: state => state.allNotifications,          

    // getTotalNotificationCount: state => state.allNotifications? state.allNotifications.length : 0,
  
    // getUnreadNotification: state => state.allNotifications? state.allNotifications.filter(n => !n.opened_at) : null,
    
    // getUnreadNotificationCount: state => state.allNotifications? state.allNotifications.filter(n => !n.opened_at).length : 0,
  },

  mutations: {
    setOneNotification(state, Notification){
      state.oneNotification = Notification // Notification.data
    },
    setAllNotifications(state, {Notifications, count, index_kind}){
      // console.log('dentro do commit')
      // state.count_new_notifications = count // Notifications.data
      // state.unopenedNotifications = [...Notifications] // Notifications.data
      switch (index_kind) {
        case 'index_new': 
          // console.log('dentro do switch new')
          state.count_new_notifications = count // Notifications.data
          // console.log({Notifications})
          state.unopenedNotifications = [...Notifications] // Notifications.data
          // console.log(state.unopenedNotifications)
          // break;
          return true
        case 'index_opened':
          // console.log('dentro do switch opened')
          state.openedNotifications = [...Notifications] // Notifications.data

          return true
          // break;
        case 'index':
          state.allNotifications = Notifications // Notifications.data

          return true
          // break
        default:
          return true
          // break;
      }
    },

    viewOneNotification(state, Notification){
      let idx = state.unopenedNotifications.findIndex(n => !n.opened_at && n.id == Notification.id)
      if (idx > -1){
        // state.allNotifications.splice(idx, 1, {...Notification})
        state.unopenedNotifications.splice(idx, 1)
        state.count_new_notifications--
      }else {
        console.error('notification idx not found in state')
      }
      // encontrar a notification e setar o opened_at
    },

    viewManyNotifications(state, Notification){
      state.openedNotifications = [...state.unopenedNotifications, ...state.openedNotifications, ]
      state.unopenedNotifications = []
      state.count_new_notifications = 0
      // state.allNotifications = [...state.allNotifications.map(n => {
      //   let obj = {...n}
      //   if(!n.opened_at){
      //     obj.opened_at = new Date()
      //   }
      //   return {...obj}
      // })]
    },

    clearAllNotifications(state){
      state.allNotifications = null
    },
    clearOneNotification(state){
      state.oneNotification = null
    },
  },

  actions: {
    clearAllNotifications({commit}){
      commit('clearAllNotifications')
    },
    clearOneNotification({commit}){
      commit('clearOneNotification') 
    },

    index(context, {filter, index_kind}) {
      // console.log('chamar api notification')
      // console.log(Api.Notific)
      // console.log(Api)

      return Api.Notific[index_kind](filter).then(response => response.data).then(Notifications => {
        let count = Notifications.count? Notifications.count : 0
        Notifications = Notifications.data? 
                          Notifications.data.map(n=> n.attributes) 
                          : Object.keys(Notifications).includes('count')? 
                            [...Notifications.notifications]
                            : Notifications
        // console.log('vai chamar o commit')
        context.commit('setAllNotifications', {Notifications, count, index_kind});
        return true
      }).catch(function(error) {
        console.log(error);  
      });
    },
    show(context, Notification_id) {
      return Api.Notific.show(Notification_id).then(response => response.data).then(Notification => {
        Notification = Notification.data? Notification.data.attributes : Notification
        context.commit('setOneNotification', Notification);
        context.commit('showResponse', {msg: '', was_good: true});
      }).catch(function(error) {
        console.log(error);
      });
    },

    readNotification(context, Notification) {
      return Api.Notific.readNotification(Notification.id).then(response => response.data).then(Notification => {
        Notification = Notification.data? 
                        Notification.data.attributes 
                        : Notification.count? 
                          Notification.notification
                          : Notification
        context.commit('viewOneNotification', Notification);
      }).catch(function(error) {
        console.log(error);
      });
    },
    readManyNotifications(context) {
      return Api.Notific.readManyNotifications().then(response => response.data).then(Notification => {
        // Notification = Notification.data? Notification.data.attributes : Notification
        context.commit('viewManyNotifications');
      }).catch(function(error) {
        console.log(error);
      });
    },
  }

};

export default Notification;
